import * as React from 'react';
import { IntlProvider } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Bootstrap as BootstrapStyleGuide, ThemeProvider } from '@siteground/styleguide';
import '@siteground/styleguide/lib/styles/main.scss';

import { requestTranslations } from '../../actions';
import { chatWindowRendered, setAiAssistantThreadId } from '../../app-communication/actions/from-client-frontend';
import { getOptions } from '../../selectors/options';

import ErrorHandler from './error-handler';
import NewMessageSound from './new-message-sound';
import { App } from './app';
import { isUserLoggedFromMaco } from '../../selectors/chat-session';

export const AppProviders = () => {
  const dispatch = useDispatch();
  const i18nMessages = useSelector((store) => store.i18n.messages);
  const { ai_assistant_thread_id, theme, isEasyReadActive } = useSelector(getOptions);
  const userLoggedFromMaco = useSelector(isUserLoggedFromMaco);

  React.useEffect(() => {
    const threadId = ai_assistant_thread_id || null;
    dispatch(setAiAssistantThreadId(threadId));
  }, [ai_assistant_thread_id]);

  React.useEffect(() => {
    dispatch(chatWindowRendered());
    dispatch(requestTranslations());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (userLoggedFromMaco) {
    //return here before we load Intl, Bootstrap, Themes, App etc.
    return null;
  }

  return (
    <IntlProvider locale="en" messages={i18nMessages}>
      <ErrorHandler>
        <BootstrapStyleGuide
          context={{
            bootstrapProps: { className: 'sg-chat-bootstrap' }
          }}
        >
          <ThemeProvider theme={theme} easyRead={isEasyReadActive}>
            <NewMessageSound />
            <App />
          </ThemeProvider>
        </BootstrapStyleGuide>
      </ErrorHandler>
    </IntlProvider>
  );
};

export default AppProviders;
